module.exports = __webpack_public_path__ + "img/1.fc0fb3f7.png";